import { render, staticRenderFns } from "./QuotePaymentsHistory.vue?vue&type=template&id=765b2cd4&"
import script from "./QuotePaymentsHistory.vue?vue&type=script&lang=js&"
export * from "./QuotePaymentsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports